import React from 'react';
import { useTranslation } from 'react-i18next';

export const ChartPlaceholder: React.FC<{ height?: number }> = ({ height = 280 }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-2 flex items-center justify-center" style={{ height }}>
      <div className="text-sm text-muted dark:text-muted-dark text-center">
        {t('revenueHistory.noDataThisPeriod')}
      </div>
    </div>
  );
};
